<template>
  <section class="intro-section">
    <div class="intro-inner"> <img src="../../assets/intro/worries.png" alt="" class="worries">
      <RecommendedVendor03 />
      <div class="alert-highlight-bar">
        <p> しかし、業者選びは注意しないと<br /> <span>こんな失敗につながります…</span> </p>
      </div>
      <div class="fail-grid">
        <div class="fail-item"> <img src="../../assets/intro/fail-01.png" alt="高額請求" />
          <p>相場をはるかに<br />超える高額請求</p>
        </div>
        <div class="fail-item"> <img src="../../assets/intro/fail-02.png" alt="強引な営業" />
          <p>強引な営業<br />しつこい電話</p>
        </div>
        <div class="fail-item"> <img src="../../assets/intro/fail-03.png" alt="追加費用" />
          <p>見積もり外の<br />追加費用の請求</p>
        </div>
        <div class="fail-item"> <img src="../../assets/intro/fail-04.png" alt="工事不良" />
          <p>工事の質が悪く<br />すぐに再故障</p>
        </div>
      </div>
      <div class="trust-message"> 
        <img src="../../assets/intro/excellent-company008.png" alt=""> 
      </div>
    </div>
  </section>
</template>
<script setup>import RecommendedVendor03 from '..//recommend/RecommendedVendor03.vue' </script>
<style scoped>
.worries {
  width: 100%;
}

.intro-section {
  background: #f9fafc;
}

.intro-inner {
  max-width: 800px;
  margin: 0 auto;
}


.intro-header {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  text-align: left;
}

.fail-headline span {
  color: #0b0b97;
}

.person-img {
  width: 30%;
  flex-shrink: 0;
}

.intro-header h2 {
  font-size: 29px;
  font-weight: 700;
  color: #333;
  line-height: 1.6;
}

.highlight {
  color: #2c3e50;
  font-weight: 700;
}

/* 悩みリスト */
.problem-box {
  background: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  margin-bottom: 20px;
}

.problem-box ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.problem-box li {
  font-size: 16px;
  margin-bottom: 8px;
  line-height: 1.7;
  text-align: left;
}

.problem-box li:last-child {
  margin-bottom: 0;
}

.check {
  font-size: 20px;
  margin-right: 10px;
  flex-shrink: 0;
  line-height: 1.4;
  color: #333;
}

.alert-highlight-bar {
  background: #b31d19;
  color: #fff;
  font-size: 1.2rem;
  margin: 20px;
  font-weight: 700;
  text-align: center;
  padding: 18px 12px;
  border-radius: 4px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 20px;
}

.alert-ico {
  width: 15%;
  margin-bottom: 10px;
}

.alert-highlight-bar span {
  color: #ffeb3b;
}

.alert-highlight-bar::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 15px 15px 0 15px;
  border-style: solid;
  border-color: #b31d19 transparent transparent transparent;
}

.alert-highlight-bar p {
  margin: 0;
  padding: 0;
}

.fail-headline {
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin: 25px 0 20px;
  color: #333;
}

.fail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin: 20px;
}

.trust-message img {
  width: 80%;
  margin-top: 10px;
}

.worries,
.recommended {
  width: 90%;
  padding: 20px;
  padding-bottom: 0;
}

.trust-message img {
  padding: 20px;
}

.fail-item {
  background: #9e9e9e38;
  border: 1px solid #ddd;
  text-align: center;
  padding: 15px;
  border-radius: 4px;
}

.fail-item img {
  width: 70%;
}

.fail-item p {
  font-weight: 700;
  margin: 0;
  font-size: 0.8rem;
  color: #fff;
  background: #716e6e;
  padding: 8px 10px;
  border-radius: 3px;
  line-height: 1.5;
}

.trust-message p {
  margin: 0;
  color: #333;
  padding: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.6;
}

.trust-message span {
  font-size: 1.2rem;
}

@media (max-width: 480px) {
  .intro-section {
    padding: 0;
  }

  .alert-highlight-bar {
    border-radius: 0;
  }

  .alert-highlight-bar p {
    font-size: 1.1rem;
  }

  .fail-item {
    padding: 5px;
  }

  .fail-item img {
    width: 70%;
  }

  .fail-item p {
    font-size: 0.8rem;
  }

  .trust-message img {
    width: 90%;
    padding-top: 10px;
    padding-bottom: 15px;
  }

  .fail-grid {
    padding: 10px;
  }
}
</style>